import { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import { FormCommentPopover } from 'pages/FormProcess/components/FormCommentPopover';
import { getElementByQuerySelector, preparePositionedThreads } from './helper';

import styles from './styles.module.scss';
import { CommentUsersType, ListType } from 'types';

type CommentsListType = {
  threads: any;
  onHighlightThread: (uuid) => void;
  selectedUUID: string;
  commentUsers?: CommentUsersType;
  commentActions: any;
  listType?: ListType;
  listRightOffset?: number;
};

const LIST_OFFSET = 40;

export const CommentsList = ({
  threads,
  onHighlightThread,
  selectedUUID,
  commentUsers,
  commentActions,
  listType,
  listRightOffset = 0,
}: CommentsListType) => {
  const [activeUUID, setActiveUUID] = useState<string>();

  useEffect(() => {
    setActiveUUID(selectedUUID);
  }, [selectedUUID]);

  const onCommentClick = (highlightedUUID) => {
    setActiveUUID(highlightedUUID);
    onHighlightThread(highlightedUUID);
  };

  const renderThreadsIndicatorList = useCallback(() => {
    const flatThreads = Object.values(threads).flat();
    const positionedThreads = preparePositionedThreads(flatThreads, activeUUID);

    return positionedThreads.map((item, i) => {
      return (
        <FormCommentPopover
          key={item.Id}
          zIndex={9999}
          dynamicComment
          hideTooltipTitle
          isNewThread={false}
          listType={listType}
          {...commentActions}
          fieldId={item.fieldId}
          threads={[item] as any}
          commentUsers={commentUsers}
          defaultOpenPopover={item.fieldUUID === activeUUID}
          onCommentClick={() => onCommentClick(item.fieldUUID)}
          tooltipStyles={{ right: -50, top: item.top, transition: 'top 0.4s ease' }}
        />
      );
    });
  }, [threads, activeUUID]);

  return (
    <div
      id="comments-sidebar-list"
      className={styles.commentsListSidebar}
      style={{ right: listRightOffset * LIST_OFFSET + 0 }}
    >
      {renderThreadsIndicatorList()}
    </div>
  );
};
